import { parseBboxTuple } from '../../hooks/use-debounced-bbox';

/**
 * True when a `lat`/`lng` coordinate-search deep link (catalog "open on map"
 * / POI "show on map") is present. Such a link always represents where the
 * user explicitly wants to look and must win over a stale remembered bbox
 * from a previous session (CU-86cb1nq31). Exported as the single source of
 * truth for this specific check, used by `resolveInitialBounds` below.
 *
 * lat/lng stripping itself lives entirely in `setMapBbox`
 * (`use-map-page-state.ts`, via the `stripLatLng` reducer) — not here, and
 * not as a separate mount-time effect in `routes/map/index.tsx` (an earlier
 * version did that and had a real bug: stripping on mount raced the map's
 * own initial-camera setup under React StrictMode, see setMapBbox's own doc
 * comment for the full writeup).
 */
export function hasCoordinateDeepLink(lat: number | undefined, lng: number | undefined): boolean {
  return lat != null || lng != null;
}

/**
 * Decides whether the map's initial camera should restore the last-persisted
 * `viewBbox`, or defer to `initialCenter`/`initialZoom` (or nothing) instead.
 */
export function resolveInitialBounds(
  lat: number | undefined,
  lng: number | undefined,
  viewBbox: string | undefined,
): [number, number, number, number] | null {
  if (hasCoordinateDeepLink(lat, lng)) return null;
  return parseBboxTuple(viewBbox);
}
